import { render, staticRenderFns } from "./partnerRemittanceRanking.vue?vue&type=template&id=4e8c985f&scoped=true&"
import script from "./partnerRemittanceRanking.vue?vue&type=script&lang=js&"
export * from "./partnerRemittanceRanking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8c985f",
  null
  
)

export default component.exports